interface SimpleTabProps {
  label: string;
}

export default function SimpleTab({ label }: SimpleTabProps) {
  return (
    <div className="user-profile__content">
      <div className="user-profile__main user-profile__main--full">
        <div className="user-profile__main-header">
          <span className="user-profile__main-title">{label}</span>
        </div>
        <div className="user-profile__main-divider" />
        <div className="up-placeholder">
          <p>Em breve</p>
        </div>
      </div>
    </div>
  );
}
